import { BUNDLE, HEAT_AND_EAT, STANDARD, TEMPO, SPICY } from 'lib/constants';

export const isExtraOutsideBundleAndLunch = meal =>
  meal.aLaCarte &&
  meal.primaryLabelData?.labelText !== BUNDLE &&
  meal.primaryLabelData?.labelText !== HEAT_AND_EAT;
export const isBundle = meal => meal.aLaCarte && meal.primaryLabelData?.labelText === BUNDLE;
export const isExtra = meal => meal.aLaCarte;
export const isHeatAndEat = meal => meal.primaryLabelData?.labelText === HEAT_AND_EAT;

export const shouldShowMealTitleSpiceIcon = ({ spiceLevel, mealPlanSlug }) =>
  spiceLevel === SPICY && mealPlanSlug && mealPlanSlug !== STANDARD;

export const normalizeMealTitle = title => {
  const emojiRegex = /🌶️?/gu;
  const titleHasEmoji = emojiRegex.test(title);

  return titleHasEmoji ? title.replace(emojiRegex, '').trim() : title;
};

export const mealImageToDisplay = (
  meal,
  isExpressPlusSaturationExperimentVariant = false,
  isPremiumSideAngleExperimentVariant = false,
  isHneTrayImageExperimentVariant = false
) => {
  if (!meal) return null;

  const { photoVariants } = meal;
  const isTempoMeal = photoVariants?.mealPlanSlug === TEMPO;
  const isHeatAndEatMeal = isHeatAndEat(meal);
  const defaultPhoto = meal.photo || meal.image || meal.imageUrl;

  if (!isTempoMeal && isExpressPlusSaturationExperimentVariant && photoVariants?.variant1Photo) {
    return photoVariants.variant1Photo;
  }

  if (isTempoMeal && isPremiumSideAngleExperimentVariant && photoVariants?.variant1Photo) {
    return photoVariants.variant1Photo;
  }

  if (
    !isTempoMeal &&
    isHeatAndEatMeal &&
    isHneTrayImageExperimentVariant &&
    photoVariants?.variant1Photo
  ) {
    return photoVariants.variant1Photo;
  }

  return defaultPhoto;
};
